import { Box } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "features/store";
import { api } from "features/api";
import { clearClientView } from "features/clientView/clientViewSlice";
import ClientViewHeader from "./ClientViewHeader";
import { theme } from "../hoc/Theme";
import { ThemeProvider } from "@mui/material/styles";
import CustomScrollbars from "../CustomScrollbars";
import Footer from "../Footer";
import { ClientViewProvider } from "contexts/ClientViewContext";

export default function ClientViewLayout() {
  const { userId } = useParams<{ userId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const fileSystemFullBleed = location.pathname.includes("/data-storage");
  const dispatch = useAppDispatch();
  const clientView = useAppSelector((state) => state.clientView);

  useEffect(() => {
    const id = userId ? Number(userId) : null;
    if (id == null || Number.isNaN(id)) {
      navigate("/user-management", { replace: true });
      return;
    }
    if (!clientView.active || clientView.userId !== id) {
      navigate("/user-management", { replace: true });
    }
  }, [userId, clientView.active, clientView.userId, navigate]);

  const handleBack = () => {
    dispatch(clearClientView());
    dispatch(api.util.resetApiState());
    navigate("/user-management");
  };

  if (!clientView.active || clientView.userId === null) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: "100vh",
          minHeight: 0,
          maxHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
          overflow: "hidden",
        }}
      >
        <ClientViewHeader onBackToUserManagement={handleBack} />

        <Box
          component="main"
          sx={{
            flex: "1 1 0",
            pt: { xs: "56px", md: "80px" },
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            ...(fileSystemFullBleed && {
              maxHeight: { xs: "calc(100vh - 56px - 80px)", md: "calc(100vh - 80px - 80px)" },
            }),
            overflow: "hidden",
          }}
        >
          {fileSystemFullBleed ? (
            <Box
              sx={{
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <ClientViewProvider value={true}>
                <Outlet />
              </ClientViewProvider>
            </Box>
          ) : (
            <CustomScrollbars sx={{ flex: 1, minHeight: 0 }}>
              <ClientViewProvider value={true}>
                <Outlet />
              </ClientViewProvider>
            </CustomScrollbars>
          )}
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
}
